/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Document Cognition Service
 * OpenAPI spec version: 1.0.0
 */

/**
 * A `provider/model` id every user may request without professional features.
 */
export type FreeTierModel = (typeof FreeTierModel)[keyof typeof FreeTierModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FreeTierModel = {
  'google/gemini-38-flash': 'google/gemini-3.8-flash',
} as const;
